import { useState, useRef } from "react";

const App = () => {
  const [messages, setMessages] = useState([
    {
      role: "assistant",
      content: "Hi! I'm Rika, your All in One UK Property Buddy for Buyers, Tenants, Landlords or Estate Agents. Tell me what you're looking for!",
    },
  ]);
  const [input, setInput] = useState("");
  const [loading, setLoading] = useState(false);
  const [links, setLinks] = useState(null);
  const [listings, setListings] = useState(null);
  const [listening, setListening] = useState(false);
  const [unlocked, setUnlocked] = useState(false);
  const [password, setPassword] = useState("");
  const [mode, setMode] = useState("tenant");
  const bottomRef = useRef(null);

  const startVoice = () => {
    const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
    if (!SpeechRecognition) {
      alert("Your browser doesn't support voice. Please use Chrome!");
      return;
    }
    const recognition = new SpeechRecognition();
    recognition.lang = "en-GB";
    recognition.start();
    setListening(true);
    recognition.onresult = (e) => {
      setInput(e.results[0][0].transcript);
      setListening(false);
    };
    recognition.onerror = () => setListening(false);
    recognition.onend = () => setListening(false);
  };

  const switchMode = (newMode) => {
    setMode(newMode);
    setMessages([{
      role: "assistant",
      content: newMode === "landlord" 
        ? "Hi! I'm Rika. I'll help you list your property on Rikanverse. Let's get started! What's your name?"
        : "Hi! I'm Rika, your All in One UK Property Buddy. Are you looking to buy or rent?"
    }]);
    setLinks(null);
    setListings(null);
  };

  const sendMessage = async () => {
    if (!input.trim()) return;
    const userMsg = { role: "user", content: input };
    const newHistory = [...messages, userMsg];
    setMessages(newHistory);
    setInput("");
    setLoading(true);

    try {
      const res = await fetch("https://rikanverse-proptech-production.up.railway.app/chat", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          message: input,
          history: messages.map((m) => ({
            role: m.role,
            content: m.content,
          })),
          mode: mode,
        }),
      });
      const data = await res.json();
      setMessages([...newHistory, { role: "assistant", content: data.response }]);
      if (data.links) setLinks(data.links);
      if (data.rikanverse_listings) setListings(data.rikanverse_listings);
      if (data.listing_saved) {
        setMessages(prev => [...prev, {
          role: "assistant",
          content: "🎉 Your property has been listed on Rikanverse! Tenants will be able to find it soon."
        }]);
      }
    } catch (e) {
      setMessages([...newHistory, { role: "assistant", content: "Sorry, something went wrong!" }]);
    }
    setLoading(false);
    bottomRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  if (!unlocked) {
    return (
      <div style={{
        minHeight: "100vh",
        background: "url('/rikanverseimage.png') center/cover no-repeat fixed",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        fontFamily: "'Segoe UI', sans-serif",
      }}>
        <div style={{
          background: "rgba(255,255,255,0.05)",
          borderRadius: "20px",
          border: "1px solid rgba(126,184,247,0.2)",
          backdropFilter: "blur(10px)",
          padding: "40px",
          textAlign: "center",
          maxWidth: "400px",
          width: "90%",
        }}>
          <h1 style={{ color: "#fff", fontSize: "1.8rem", marginBottom: "8px" }}>RIKANVERSE</h1>
          <p style={{ color: "#7eb8f7", marginBottom: "24px" }}>Closed Beta — Enter Access Code</p>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter" && password === "Radha&krishna1992") setUnlocked(true);
            }}
            placeholder="Enter access code..."
            style={{
              width: "100%",
              padding: "12px 16px",
              borderRadius: "10px",
              border: "1px solid rgba(126,184,247,0.3)",
              background: "rgba(255,255,255,0.07)",
              color: "#fff",
              fontSize: "1rem",
              outline: "none",
              marginBottom: "12px",
              boxSizing: "border-box",
            }}
          />
          <button
            onClick={() => {
              if (password === "Radha&krishna1992") setUnlocked(true);
              else alert("Wrong access code!");
            }}
            style={{
              width: "100%",
              padding: "12px",
              borderRadius: "10px",
              border: "none",
              background: "linear-gradient(135deg, #1a56db, #0a2463)",
              color: "#fff",
              fontWeight: "700",
              fontSize: "1rem",
              cursor: "pointer",
            }}>
            Enter Beta →
          </button>
        </div>
      </div>
    );
  }

  return (
    <div style={{
      minHeight: "100vh",
      background: "url('/rikanverseimage.png') center/cover no-repeat fixed",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      fontFamily: "'Segoe UI', sans-serif",
      padding: "20px",
    }}>
      <div style={{ textAlign: "center", marginBottom: "16px" }}>
        <h1 style={{
          color: "#fff",
          fontSize: "2rem",
          fontWeight: "700",
          letterSpacing: "1px",
          margin: 0,
        }}>RIKANVERSE</h1>
        <p style={{ color: "#7eb8f7", margin: "6px 0 16px", fontSize: "0.95rem" }}>
          All in One UK Property Buddy for Buyers, Tenants, Landlords or Estate Agents.
        </p>

        {/* Mode Toggle */}
        <div style={{ display: "flex", gap: "10px", justifyContent: "center" }}>
          <button
            onClick={() => switchMode("tenant")}
            style={{
              padding: "8px 20px",
              borderRadius: "20px",
              border: "none",
              background: mode === "tenant" ? "linear-gradient(135deg, #1a56db, #0a2463)" : "rgba(255,255,255,0.1)",
              color: "#fff",
              fontWeight: "600",
              cursor: "pointer",
              fontSize: "0.9rem",
            }}>
            🔍 I'm Looking
          </button>
          <button
            onClick={() => switchMode("landlord")}
            style={{
              padding: "8px 20px",
              borderRadius: "20px",
              border: "none",
              background: mode === "landlord" ? "linear-gradient(135deg, #7c3aed, #4c1d95)" : "rgba(255,255,255,0.1)",
              color: "#fff",
              fontWeight: "600",
              cursor: "pointer",
              fontSize: "0.9rem",
            }}>
            🏠 I'm a Landlord
          </button>
        </div>
      </div>

      <div style={{
        width: "100%",
        maxWidth: "700px",
        background: "rgba(255,255,255,0.05)",
        borderRadius: "20px",
        border: "1px solid rgba(126,184,247,0.2)",
        backdropFilter: "blur(10px)",
        padding: "24px",
        minHeight: "400px",
        maxHeight: "500px",
        overflowY: "auto",
        marginBottom: "16px",
      }}>
        {messages.map((m, i) => (
          <div key={i} style={{
            display: "flex",
            justifyContent: m.role === "user" ? "flex-end" : "flex-start",
            marginBottom: "12px",
          }}>
            <div style={{
              background: m.role === "user"
                ? "linear-gradient(135deg, #1a56db, #0a2463)"
                : "rgba(255,255,255,0.08)",
              color: "#fff",
              borderRadius: m.role === "user" ? "18px 18px 4px 18px" : "18px 18px 18px 4px",
              padding: "12px 16px",
              maxWidth: "75%",
              fontSize: "0.95rem",
              lineHeight: "1.5",
              border: m.role === "assistant" ? "1px solid rgba(126,184,247,0.15)" : "none",
            }}>
              {m.content}
            </div>
          </div>
        ))}
        {loading && (
          <div style={{ color: "#7eb8f7", fontSize: "0.9rem" }}>Rika is typing...</div>
        )}
        <div ref={bottomRef} />
      </div>

      {/* Rikanverse Own Listings */}
      {listings && listings.length > 0 && (
        <div style={{
          width: "100%",
          maxWidth: "700px",
          background: "rgba(255,255,255,0.05)",
          borderRadius: "16px",
          border: "1px solid rgba(126,184,247,0.3)",
          padding: "16px 24px",
          marginBottom: "16px",
        }}>
          <p style={{ color: "#7eb8f7", margin: "0 0 12px", fontWeight: "600" }}>
            ✨ Rikanverse Direct Listings:
          </p>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "12px" }}>
            {listings.map((l) => (
              <div key={l.id} style={{
                background: "rgba(255,255,255,0.07)",
                borderRadius: "12px",
                padding: "12px",
                border: "1px solid rgba(126,184,247,0.2)",
              }}>
                <p style={{ color: "#fff", margin: "0 0 4px", fontWeight: "600" }}>
                  {l.bedrooms} bed {l.property_type} — {l.location}
                </p>
                <p style={{ color: "#7eb8f7", margin: "0 0 4px", fontSize: "1.1rem", fontWeight: "700" }}>
                  £{l.price}/month
                </p>
                <p style={{ color: "rgba(255,255,255,0.6)", margin: "0", fontSize: "0.8rem" }}>
                  {l.description}
                </p>
                <p style={{ color: "#7eb8f7", margin: "4px 0 0", fontSize: "0.8rem" }}>
                  📧 {l.contact_email}
                </p>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* External Links */}
      {links && (
        <div style={{
          width: "100%",
          maxWidth: "700px",
          background: "rgba(255,255,255,0.05)",
          borderRadius: "16px",
          border: "1px solid rgba(126,184,247,0.2)",
          padding: "16px 24px",
          marginBottom: "16px",
        }}>
          <p style={{ color: "#7eb8f7", margin: "0 0 12px", fontWeight: "600" }}>
            🔗 More Properties:
          </p>
          <div style={{ display: "flex", gap: "12px", flexWrap: "wrap" }}>
            {links.spareroom && (
              <a href={links.spareroom} target="_blank" rel="noreferrer" style={{
                background: "linear-gradient(135deg, #1a56db, #0a2463)",
                color: "#fff",
                padding: "10px 20px",
                borderRadius: "10px",
                textDecoration: "none",
                fontWeight: "600",
                fontSize: "0.9rem",
              }}>SpareRoom</a>
            )}
            {links.zoopla && (
              <a href={links.zoopla} target="_blank" rel="noreferrer" style={{
                background: "linear-gradient(135deg, #1a56db, #0a2463)",
                color: "#fff",
                padding: "10px 20px",
                borderRadius: "10px",
                textDecoration: "none",
                fontWeight: "600",
                fontSize: "0.9rem",
              }}>🔍 Zoopla</a>
            )}
            {links.mortgage && (
              <a href="https://www.habito.com" target="_blank" rel="noreferrer" style={{
                background: "linear-gradient(135deg, #16a34a, #064e3b)",
                color: "#fff",
                padding: "10px 20px",
                borderRadius: "10px",
                textDecoration: "none",
                fontWeight: "600",
                fontSize: "0.9rem",
              }}>💰 Mortgage Rates</a>
            )}
          </div>
        </div>
      )}

      <div style={{
        width: "100%",
        maxWidth: "700px",
        display: "flex",
        gap: "10px",
      }}>
        <input
          value={input}
          onChange={(e) => setInput(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && sendMessage()}
          placeholder={mode === "landlord" ? "Tell Rika about your property..." : "Tell Rika what you're looking for..."}
          style={{
            flex: 1,
            padding: "14px 20px",
            borderRadius: "12px",
            border: "1px solid rgba(126,184,247,0.3)",
            background: "rgba(255,255,255,0.07)",
            color: "#fff",
            fontSize: "0.95rem",
            outline: "none",
          }}
        />
        <button
          onClick={sendMessage}
          disabled={loading}
          style={{
            padding: "14px 24px",
            borderRadius: "12px",
            border: "none",
            background: "linear-gradient(135deg, #1a56db, #0a2463)",
            color: "#fff",
            fontWeight: "700",
            fontSize: "0.95rem",
            cursor: "pointer",
          }}>
          Send
        </button>
        <button
          onClick={startVoice}
          disabled={listening}
          style={{
            padding: "14px 20px",
            borderRadius: "12px",
            border: "none",
            background: listening
              ? "linear-gradient(135deg, #dc2626, #7f1d1d)"
              : "linear-gradient(135deg, #7c3aed, #4c1d95)",
            color: "#fff",
            fontWeight: "700",
            fontSize: "0.95rem",
            cursor: "pointer",
          }}>
          {listening ? "🔴 Listening..." : "🎤 Speak"}
        </button>
      </div>
    </div>
  );
};

export default App;